export default {
  footer: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/layouts/Footer.vue").then(m => m.default || m),
  header: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/layouts/Header.vue").then(m => m.default || m),
  default: () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/layouts/default.vue").then(m => m.default || m),
  "no-footer": () => import("/Users/xiongzhifan/yinuo/proj_codes/PixelHaha-SSR/layouts/noFooter.vue").then(m => m.default || m)
}